/**
 * Relyxi variant sync.
 * One product, several add-to-cart forms and swatch groups (hero, what's in the box,
 * final CTA, sticky bar). Clicking a swatch anywhere updates every form's hidden `id`
 * input, every price, every swatch group, the sticky bar thumbnail and scrolls the hero
 * gallery to that variant's image.
 *
 * Markup contract:
 *  - <script type="application/json" data-rx-variant-data>  [{id, title, available, price, compareAt, mediaIndex, image}]
 *  - button[data-rx-variant="<id>"]         swatch (any number of groups)
 *  - input[data-rx-variant-input]           hidden id input inside each form
 *  - [data-rx-price] / [data-rx-compare]    price outputs
 *  - [data-rx-variant-label]                shows the selected option name
 */

if (!window.__rxVariantsBound) {
  window.__rxVariantsBound = true;

  const parseVariants = () => {
    try {
      return JSON.parse(document.querySelector('script[data-rx-variant-data]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const scrollGalleryTo = (index) => {
    const track = document.querySelector('[data-rx-gallery-track]');
    if (!track || index == null || index < 0) return;
    const slide = track.children[index];
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  const initVariants = () => {
    const variants = parseVariants();
    const swatches = document.querySelectorAll('[data-rx-variant]');
    if (variants.length < 2 || !swatches.length) return;

    const select = (variantId, { scroll = true } = {}) => {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      document.querySelectorAll('input[data-rx-variant-input]').forEach((input) => {
        input.value = variant.id;
      });

      document.querySelectorAll('[data-rx-price]').forEach((el) => {
        el.textContent = variant.price;
      });

      document.querySelectorAll('[data-rx-compare]').forEach((el) => {
        el.textContent = variant.compareAt || '';
        el.hidden = !variant.compareAt;
      });

      document.querySelectorAll('[data-rx-variant-label]').forEach((el) => {
        el.textContent = variant.title;
      });

      document.querySelectorAll('[data-rx-sticky-image]').forEach((img) => {
        if (variant.image) img.src = variant.image;
      });

      swatches.forEach((button) => {
        const isActive = String(button.dataset.rxVariant) === String(variant.id);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      document.querySelectorAll('form[data-rx-atc] button[type="submit"]').forEach((button) => {
        button.disabled = variant.available === false;
      });

      if (scroll) scrollGalleryTo(variant.mediaIndex);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    swatches.forEach((button) => {
      button.addEventListener('click', () => select(button.dataset.rxVariant));
    });

    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    const initial = variants.find((item) => String(item.id) === String(fromUrl)) || variants[0];
    select(initial.id, { scroll: false });
  };

  initVariants();
}
